export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

export const Name_REGEX = /^[A-Za-z ]+$/;

export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

export const TITLE_REGEX = /^(?!\s*$).+/;

export const Mobile_REGEX = /^[0-9]{10}$/;